import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { deleteAttribute, listAttributes } from '../actions/attributeActions';
import { AlertMessage } from '../components/AlertMessage';
import { CustomDataTable } from '../components/CustomDataTable';
import { LoadingBox } from '../components/LoadingBox';
import { ToolBar } from '../components/ToolBar'
import Swal from 'sweetalert2';
import { ATTRIBUTE_DELETE_RESET } from '../constants/attributeConstants';
import { Link } from 'react-router-dom';
import { getNotificationsUser } from '../actions/notificationActions';

export const AttributeListScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const attributeList = useSelector((state) => state.attributeList);
    const { loading, error, attributes } = attributeList;

    const attributeCreate = useSelector((state) => state.attributeCreate);
    const {loading: loadingCreate, error: errorCreate } = attributeCreate;
  
    const attributeDelete = useSelector((state) => state.attributeDelete);
    const { loading: loadingDelete, error: errorDelete, success: successDelete } = attributeDelete;

    const columns = [
        {
            name: 'Atributo',
            cell: row =>
                <div className="d-flex align-items-center">                    
                    <div className="ms-5">
                        <a href={`/attribute/${row._id}/edit`} className="text-gray-800 text-hover-primary fs-5 fw-bolder" data-kt-ecommerce-product-filter="attribute_name">{row.name}</a>
                    </div>
                </div>,
            selector: (row) => row.name,            
            sortable: true,            
        },

        {
            name: "",
            cell: row =>
            <div className="row">
                <div className="col-12">
                <i className="bi bi-pencil px-2" onClick={() => navigate(`/attribute/${row._id}/edit`)} style={{fontSize: '1.4rem', cursor: 'pointer'}}></i>
                <i className="bi bi-trash-fill px-2" onClick={() => deleteHandler(row)} style={{fontSize: '1.4rem', cursor: 'pointer'}}></i>
                </div>
            </div>,
                // <div className="dropdown dropup">
                //     <button className="btn btn-sm btn-light btn-active-light-primary" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                //         Acciones
                //         <span className="svg-icon svg-icon-5 m-0">
                //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                //                 <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="black" />
                //             </svg>
                //         </span>
                //     </button>
                //     <ul className="dropdown-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4" aria-labelledby="dropdownMenuButton1">
                //         <li className="menu-item px-3"><button className="dropdown-item menu-link px-3" onClick={() => navigate(`/attribute/${row._id}/edit`)} >Editar</button></li>
                //         <li className="menu-item px-3"><button className="dropdown-item menu-link px-3" onClick={() => deleteHandler(row)} >Eliminar</button></li>
                //     </ul>
                // </div>,
            right: true,
        }
    ];

    const deleteHandler = (attribute) => {
        Swal.fire({
            title: `¿Desea eliminar el atributo ${attribute.name} ?`,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: 'No',
            cancelButtonText: "Cancelar",
            icon: "warning",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteAttribute(attribute._id));
                Swal.fire('Atributo eliminado', '', 'success')
            }
        })
    }

    useEffect(() => {
        if (successDelete) {
            dispatch({ type: ATTRIBUTE_DELETE_RESET });
        }
        dispatch({ type: ATTRIBUTE_DELETE_RESET });
        dispatch(listAttributes());
        dispatch(getNotificationsUser());
    }, [dispatch, navigate, successDelete])



    return (
        <>
            <ToolBar titulo={"Atributos"} hitos={[
                { titulo: "Inicio", enlace: "/" },
                { titulo: "Atributos", enlace: "#" },
            ]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <div className="content flex-row-fluid" id="kt_content">
                    {loadingDelete && (<LoadingBox variant={"primary"}/>)}
                    {errorDelete && (<AlertMessage variant={"danger"} message={errorDelete}/>)}
                    {loadingCreate && (<LoadingBox variant={"primary"}/>)}
                    {errorCreate && (<AlertMessage variant={"danger"} message={errorCreate}/>)}
                    {loading ? (<LoadingBox variant={"primary"} />) :
                        error ? (<AlertMessage variant={"danger"} message={error} />) : (
                            <div className="card card-flush">
                                <div className="card-header align-items-center py-5 gap-2 gap-md-5">
                                    <div className="card-toolbar flex-row-fluid justify-content-end gap-5">
                                        <Link to={'/attribute/new'} className="btn btn-primary">Crear atributo</Link>
                                    </div>
                                </div>
                                <div className="card-body pt-0">
                                    <CustomDataTable data={attributes} columns={columns} />
                                </div>
                            </div>
                        )}
                </div>
            </div>
        </>
    )
}
